import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Field, Form } from 'react-final-form';
import { Container, Col, Row, Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { actions } from '../../../context';
import { useHistory } from 'react-router-dom';
import FieldTitle from '../../Forms/FieldTitle';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import toast from 'react-hot-toast';

const BitwerxOfferingForm = ({
    bitwerxOffering = {},
    refresh,
    closeForm,
    isNew = false,
}) => {
    const dispatch = useDispatch();
    let history = useHistory();

    const submit = async (values) => {
        const payload = { ...values };
        payload.name = '';
        if (payload.newName) payload.name = payload.newName;
        if (isNew === true) {
            dispatch(actions.offerings.createBitwerxOffering(payload))
                .then((res) => {
                    if (res) {
                        history.push('/admin/bitwerxofferings/' + res);
                        refresh();
                        closeForm();
                    }
                })
                .catch((err) =>
                    console.error('New Bitwerx Offering error: ', err)
                );
        } else {
            dispatch(
                actions.offerings.updateBitwerxOffering(payload.id, payload)
            )
                .then((res) => {
                    if (res) {
                        refresh();
                        closeForm();
                    }
                })
                .catch((err) => console.error(err));
        }
    };

    const isRequired = () => isNew === true;

    return (
        <Form
            initialValues={bitwerxOffering}
            onSubmit={submit}
            mutators={{
                ...arrayMutators,
            }}
            render={({
                handleSubmit,
                form,
                submitting,
                pristine,
                values,
                form: {
                    mutators: { push },
                },
            }) => (
                <form onSubmit={handleSubmit}>
                    <Container>
                        <Row>
                            <Col lg="6" md="6" sm="12" xs="12" className="mb-4">
                                <FieldTitle
                                    title="Bitwerx Offering Name"
                                    required={isRequired()}
                                />
                                <Row className="align-items-center">
                                    <Col xs="11">
                                        <Field
                                            className="p-2 rounded w-100 border"
                                            component="input"
                                            name="newName"
                                            placeholder={values.name}
                                            required={isRequired()}
                                        />
                                    </Col>
                                    {isNew || (
                                        <Col xs="1">
                                            <span
                                                onClick={() => {
                                                    if (
                                                        !window.confirm(
                                                            `Delete Bitwerx Offering: ${bitwerxOffering.name}?`
                                                        )
                                                    )
                                                        return;
                                                    dispatch(
                                                        actions.offerings.deleteBitwerxOffering(
                                                            bitwerxOffering.id
                                                        )
                                                    )
                                                        .then(() => {
                                                            toast(
                                                                () => (
                                                                    <div className="text-light d-flex justify-content-between w-100">
                                                                        Success:
                                                                        Offering{' '}
                                                                        {
                                                                            bitwerxOffering.name
                                                                        }{' '}
                                                                        is
                                                                        deleted
                                                                    </div>
                                                                ),
                                                                {
                                                                    duration: 7500,
                                                                    style: {
                                                                        minWidth:
                                                                            '25vw',
                                                                        background:
                                                                            'green',
                                                                    },
                                                                }
                                                            );
                                                            history.push(
                                                                '/admin/bitwerxofferings/'
                                                            );
                                                            refresh({skipOfferingRefresh: true});
                                                            closeForm();
                                                        })
                                                        .catch(() =>
                                                            form.reset()
                                                        );
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                }}>
                                                ❌
                                            </span>
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col lg="6" md="6" sm="12" xs="12" className="mb-2">
                                <Button
                                    color="success"
                                    onClick={() =>
                                        push('subOfferings', { name: undefined, displayName: undefined, addition: true})
                                    }>
                                    Add Sub Offering
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FieldArray name="subOfferings">
                                    {({ fields }) =>
                                        fields.map((field, index) => {
                                            let subOffering =
                                                fields?.value?.[index];
                                            return (
                                                <div
                                                    key={
                                                        subOffering?.id || index
                                                    }>
                                                    <Row className="mb-1">
                                                        {/* <Col xs="0.5">
                                                            <label >Name:</label>
                                                        </Col> */}
                                                        <Col xs="5">
                                                            <Field
                                                                disabled={!isNew && !subOffering?.addition}
                                                                name={`${field}.name`}
                                                                component="input"
                                                                placeholder="Entity Name"
                                                                style={{
                                                                    width: 'inherit',
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col xs="0.5">
                                                            <label >Display:</label>
                                                        </Col>
                                                        <Col xs="5">
                                                            
                                                            <Field
                                                                name={`${field}.displayName`}
                                                                component="input"
                                                                placeholder="Display Name"
                                                                style={{
                                                                    width: 'inherit',
                                                                }}
                                                            />
                                                        </Col>
                                                        {!isNew && subOffering && (
                                                            <Col xs="1">
                                                                <span
                                                                    onClick={() => {
                                                                        fields.remove(
                                                                            index
                                                                        );
                                                                        dispatch(
                                                                            actions.offerings.deleteBitwerxSubOffering(
                                                                                subOffering.id
                                                                            )
                                                                        )
                                                                            .then(
                                                                                () => {
                                                                                    toast(
                                                                                        () => (
                                                                                            <div className="text-light d-flex justify-content-between w-100">
                                                                                                Success:
                                                                                                Sub
                                                                                                Offering{' '}
                                                                                                {
                                                                                                    subOffering.name
                                                                                                }{' '}
                                                                                                is
                                                                                                deleted
                                                                                            </div>
                                                                                        ),
                                                                                        {
                                                                                            duration: 7500,
                                                                                            style: {
                                                                                                minWidth:
                                                                                                    '25vw',
                                                                                                background:
                                                                                                    'green',
                                                                                            },
                                                                                        }
                                                                                    );
                                                                                    refresh({skipOfferingListRefresh: true});
                                                                                }
                                                                            )
                                                                            .catch(
                                                                                () =>
                                                                                    form.reset()
                                                                            );
                                                                    }}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                    }}>
                                                                    ❌
                                                                </span>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </div>
                                            );
                                        })
                                    }
                                </FieldArray>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="d-flex justify-content-between">
                                <div>
                                    <Button
                                        color="danger"
                                        disabled={pristine}
                                        onClick={() => form.reset()}>
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                        &emsp;Clear
                                    </Button>
                                </div>
                                <div className="text-right">
                                    <Button
                                        className="mx-2"
                                        color="danger"
                                        onClick={closeForm}>
                                        Cancel
                                    </Button>
                                    <Button
                                        className="mx-2"
                                        type="submit"
                                        color="success"
                                        disabled={pristine || submitting}>
                                        Submit
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </form>
            )}
        />
    );
};

export default BitwerxOfferingForm;
